// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_l3-0";
export var fileCarousel = "_l3-2";
export var removeFileButton = "_l3-1";